import { getPaymentOptionName } from 'domain/paymentOption';
import PaymentOptionDetails from 'domain/paymentOptionDetails';
import React, { useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import * as _ from 'lodash';

export interface PaymentOptionsSettingsProps {
    paymentOptionDetails: PaymentOptionDetails[],
    onChange(paymentOptionDetails: PaymentOptionDetails): Promise<void>,
};

const PaymentOptionsSettings: React.FC<PaymentOptionsSettingsProps> = props => {
    const [selectedPaymentOptionDetails, setSelectedPaymentOptionDetails] = useState<PaymentOptionDetails>(null);

    async function handleSelectedPaymentOptionSave(): Promise<void> {
        await props.onChange(selectedPaymentOptionDetails);
        setSelectedPaymentOptionDetails(null);
    }

    if (!props.paymentOptionDetails)
        return <></>;

    return <>
        <div className="settings-box">
            <div className="row">
                <div className="col-2"><strong>Payment option</strong></div>
                <div className="col-2"><strong>Display name</strong></div>
                <div className="col-2"><strong>Enabled for Traders</strong></div>
                <div className="col-3"><strong>Enabled for Customers</strong></div>
            </div>
            {props.paymentOptionDetails.map(pod =>
                <div className="row" key={pod.paymentOption}>
                    <div className="col-2">
                        <button className="link-button" onClick={() => setSelectedPaymentOptionDetails(pod)}>
                            {getPaymentOptionName(pod.paymentOption)}
                        </button>
                    </div>
                    <div className="col-2">
                        {pod.displayName}
                    </div>
                    <div className="col-2">
                        <Form.Check checked={pod.enabledForTraders} onChange={ev => props.onChange({ ...pod, enabledForTraders: ev.target.checked, enabledForCustomers: ev.target.checked ? pod.enabledForCustomers : false })} />
                    </div>
                    <div className="col-3">
                        <Form.Check checked={pod.enabledForCustomers} disabled={!pod.enabledForTraders} onChange={ev => props.onChange({ ...pod, enabledForCustomers: ev.target.checked })} />
                    </div>
                </div>
            )}

            {selectedPaymentOptionDetails &&
                <Modal show onHide={() => setSelectedPaymentOptionDetails(null)} backdrop="static">
                    <Modal.Header closeButton>
                        <Modal.Title>Edit Payment Option</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Label className="required">Display Name</Form.Label>
                        <Form.Control
                            type="text"
                            name="displayName"
                            value={selectedPaymentOptionDetails.displayName}
                            onChange={ev => setSelectedPaymentOptionDetails({ ...selectedPaymentOptionDetails, displayName: ev.target.value })}
                            required />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setSelectedPaymentOptionDetails(null)}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={() => handleSelectedPaymentOptionSave()}>
                            Save
                        </Button>
                    </Modal.Footer>
                </Modal>
            }
        </div>
    </>;
};

export default PaymentOptionsSettings;